module.exports = __webpack_public_path__ + "static/media/bg2.a5a4a29c.png";